import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';
import {accountReducer} from 'src/store/reducers/accountReducer';

export const rootReducer = combineReducers({
    account: accountReducer,
    form: formReducer,
});
